module.exports = __webpack_public_path__ + "img/no-tag5.70694b5c.png";